export const faqLoad = () => {
    $('.anchor-popup-button').click(() => {
        const pageUrl = window.location.href.split('#!')[0];
        const id = $(this).data('id');
        window.history.replaceState('', '', `${pageUrl}#!${id}`);
    });

    $('.anchor-popup-close, .modal-overlay-infosect-anchor').click(() => {
        const pageUrl = window.location.href.split('#!')[0];
        window.history.replaceState('', '', pageUrl);
    });

    function initFaq() {
        const anchor = window.location.href.split('#!')[1];
        const item = $(`a[data-id=${anchor}]`)[0];
        if (anchor && item) {
            item.click();
        }
    }

    setTimeout(initFaq, 500);
};
